@if (orderStatus === orderStatusValues.Payment) {
  <app-tag-status-atom
    [type]="'neutral'"
    [icon]="'icon-clock'"
    [text]="orderStatusLabels.PAYMENT.label | translate"
  ></app-tag-status-atom>
}
@if (orderStatus === orderStatusValues.LookingForDelivery) {
  <app-tag-status-atom
    [type]="'neutral'"
    [icon]="'icon-clock'"
    [text]="orderStatusLabels.LOOKING_FOR_DELIVERY.label | translate"
  ></app-tag-status-atom>
}
@if (orderStatus === orderStatusValues.Waiting) {
  <app-tag-status-atom
    [type]="'neutral'"
    [icon]="'icon-hourglass'"
    [text]="orderStatusLabels.WAITING.label | translate"
  ></app-tag-status-atom>
}
@if (orderStatus === orderStatusValues.Ready) {
  <app-tag-status-atom
    [type]="'success'"
    [icon]="'icon-n-check'"
    [text]="orderStatusLabels.READY.label | translate"
  ></app-tag-status-atom>
}
@if (orderStatus === orderStatusValues.Collected) {
  <app-tag-status-atom
    [type]="'success'"
    [icon]="'icon-n-check'"
    [text]="orderStatusLabels.COLLECTED.label | translate"
  ></app-tag-status-atom>
}
@if (orderStatus === orderStatusValues.Preparation) {
  <app-tag-status-atom
    [type]="'dark'"
    [icon]="'icon-chef-hat'"
    [text]="orderStatusLabels.PREPARATION.label | translate"
  ></app-tag-status-atom>
}
@if (orderStatus === orderStatusValues.Cancelled) {
  <app-tag-status-atom
    [type]="'error'"
    [icon]="'icon-c-remove'"
    [text]="orderStatusLabels.CANCELLED.label | translate"
  ></app-tag-status-atom>
}
